// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2hQfJ","form":"styles_form__22ZI1"};